<template>
  <div class="relative">
    <RenderHtml v-if="entry.embedData && entry.embedData.html" :html="entry.embedData.html" />
    <figcaption v-if="entry.text.html">
      <RenderHtml :html="entry.text.html"></RenderHtml>
    </figcaption>
  </div>
</template>

<script>
import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import RenderHtml from '@/modules/common/components/RenderHtml.vue';
import ArticleCardEmbed from './ArticleCardEmbed.vue';

export default defineComponent({
  components: {
    ArticleCardEmbed,
    RenderHtml,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    onMounted(() => {
      if (props.entry?.embedData?.source === 'instagram') {
        window.instgrm?.Embeds?.process();
      }
    });
  },
});
</script>
